export default class Global {

    constructor() {
    }

    getLogoUrl() {
        var logoUrl = "https://i.imgur.com/lw2C99J.png";
        return logoUrl;
    }

    getBgUrl() {
        var bgUrl = "https://i.imgur.com/0bZHhwO.png";
        return bgUrl;
    }

    popUpPanel() {
        var popUpBg = "https://i.imgur.com/VEdykrw.png";
        return popUpBg;
    }

    getWinPopup() {
        var winPopup = "https://i.imgur.com/8bncYMe.png";
        return winPopup;
    }

    getUberReward() {
        var uberReward  = "https://i.imgur.com/kl7vRMf.png";
        return uberReward;
    }

    getGaanaReward() {
        var gaanaReward = "https://i.imgur.com/XIld8pO.png"
        return gaanaReward;
    }

    getDinnerReward() {
        var dinnerReward = "https://i.imgur.com/JFNlyy5.png";
        return dinnerReward;
    }

    getZomatoReward() {
        var zomatoReward = "https://i.imgur.com/RKxRg9e.png";
        return zomatoReward;
    }

    getSwiggyReward() {
        var swiggyReward = "https://i.imgur.com/gfnzGlh.png";
        return swiggyReward;
    }

    getMakeMyTripReward() {
        var makemyTrip = "https://i.imgur.com/MheC3XV.png";
        return makemyTrip;
    }


    cancelBtn() {
        var cancelBtn = "https://i.imgur.com/8ibBOvU.png";
        return cancelBtn;
    }

    getRewardsIcon() {
        var rewardsIcon = "https://i.imgur.com/FtrPYoN.png";
        return rewardsIcon;
    }

    getGameIcon() {
        var gameIcon = "https://i.imgur.com/msgZ2Jk.png";
        return gameIcon;
    }

    confirmBtn() {
        var confirmBtn = "https://i.imgur.com/sIC1dgy.png";
        return confirmBtn;
    }

    getGreyOverlay() {
        var greyOverlay = "https://i.imgur.com/8sKCkxo.png";
        return greyOverlay;
    }

    howToPlayPanel() {
        var howToPanel = "https://i.imgur.com/37IxTRU.png";
        return howToPanel;
    }

    getTryAgain() {
        var tryAgain = "https://i.imgur.com/6pOTvth.png";
        return tryAgain;
    }

    getBullets() {
        var bulletPoint = "https://i.imgur.com/mLoqJdc.png";
        return bulletPoint;
    }

    getCoins() {
        var coin = "https://i.imgur.com/ypnKYJn.png";
        return coin;
    }

    getPlayNowBtn() {
        var playNowBtn = "https://i.imgur.com/K6pUXZr.png";
        return playNowBtn;
    }

    getPanelBg() {
        var panelBg = "https://i.imgur.com/6jIcUaK.png";
        return panelBg;
    }

    getSlotBG() {
        var slotBg = "https://i.imgur.com/efZlf87.png";
        return slotBg;
    }

    getArrow() {
        var arrow = "https://i.imgur.com/BB1VosE.png";
        return arrow;
    }

    getSlotMachineMat() {
        // var slotBg ="https://i.imgur.com/Tltsez9.png";
       // var slotBg = "https://i.imgur.com/9uasplV.png";
        //var slotBg = "https://i.imgur.com/lGLsARF.png";
        var slotBg  = "https://i.imgur.com/yzkBJOT.png";
        return slotBg;
    }

    getRectMat() {
        var rectMat = "https://i.imgur.com/QVy39NA.jpg";
        return rectMat;
    }

    getUIBoard() {
        var uiBoard = "https://i.imgur.com/vp6kmvt.png";
        return uiBoard;
    }

    getAttemptsHeart() {
        var heartIcon = "https://i.imgur.com/ri3cC79.png";
        return heartIcon;
    }

    getHomeBtnMat() {
        var homeBtnMat = "https://i.imgur.com/DItpywL.png";
        return homeBtnMat;
    }

    getSpinBtnMat() {
        var spinBtnMat = "https://i.imgur.com/thbG5QO.png";
        return spinBtnMat;
    }

    getTVMat() {
        var tvMat = "https://i.imgur.com/2lN4RRL.png";
        return tvMat;
    }

    getPhoneMat() {
        var phoneMat = "https://i.imgur.com/AmGXriB.png";
        return phoneMat;
    }

    getLaptopMat() {
        var laptopMat = "https://i.imgur.com/L9FWkHM.png";
        return laptopMat;
    }

    getBetterLuckMat() {
        var betterLuckMat = "https://i.imgur.com/tyqUte9.png";
        return betterLuckMat;
    }

    getgodRayMat() {
        var betterLuckMat = "https://i.imgur.com/d7Cqs0n.png";
        return betterLuckMat;
    }

    getSpinBtn() {
        var spinBtn = "https://i.imgur.com/6ZlR8x7.png";
        return spinBtn;
    }


    getGameModeIcon() {
        var gameIcon = "https://i.imgur.com/W0mDFKn.png";
        return gameIcon;
    }

    getRewardModeIcon() {
        var rewardIcon = "https://i.imgur.com/CzCCWlY.png";
        return rewardIcon;
    }

    
}


